import { useClientAccount } from '../account/AccountContext';

function maskedAccountId(accountId: string): string {
  return `•••• ${accountId.slice(-4)}`;
}

export default function AccountSelectionPage() {
  const { accounts, loading, error, refreshAccounts, selectAccount } = useClientAccount();

  return (
    <main className="account-selection-page">
      <section className="account-selection-card" aria-labelledby="account-selection-title">
        <div className="account-selection-heading">
          <p className="account-selection-kicker">SURELINC Readiness Platform™</p>
          <h1 id="account-selection-title">Select an AWS environment</h1>
          <p>Choose the authorized environment you want to manage. Data and AI guidance remain isolated to the selected account.</p>
        </div>

        {loading && <div className="notice">Loading authorized AWS environments…</div>}
        {error && (
          <div className="notice notice-error">
            <p>{error}</p>
            <button className="secondary-button" type="button" onClick={() => void refreshAccounts()}>Try again</button>
          </div>
        )}
        {!loading && !error && accounts.length === 0 && (
          <div className="notice notice-error">
            No active AWS environments are assigned to your account. Contact your SURELINC administrator.
          </div>
        )}

        {!loading && !error && accounts.length > 0 && (
          <div className="account-selection-grid">
            {accounts.map((account) => (
              <button
                key={account.accountId}
                className="account-selection-option"
                type="button"
                onClick={() => selectAccount(account.accountId)}
              >
                <span className="account-selection-option-title">{account.displayName || `AWS Account ${account.accountId}`}</span>
                <span className="account-selection-option-id">{maskedAccountId(account.accountId)}</span>
                <span className="account-selection-option-meta">
                  {account.cmmcLevel || 'CMMC'} · {account.region || 'Region not set'}
                  {account.isPrimary ? ' · Primary' : ''}
                </span>
                <span className="account-selection-option-role">
                  {account.accountRole === 'ACCOUNT_ADMIN' ? 'Account administrator' : 'Read-only access'}
                </span>
              </button>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
